<template>
  <v-dialog v-model="openFilter" persistent max-width="450">
    <v-card>
      <v-card-title>Filters</v-card-title>

      <v-card-text>
        <v-row>
          <v-col>
            <v-select v-model="filters.status" :items="form.status" label="Number Transfer Status" dense outlined hide-details multiple></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-select v-model="filters.portKind" :items="form.portKind" label="Port Kind" dense outlined hide-details multiple></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-select v-model="filters.productStatus" :items="form.productStatusSelect" label="Product Status" dense outlined hide-details multiple></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-select v-model="filters.automatedOrderStatus" :items="form.automatedOrderStatus" label="Automated Order Status" dense outlined hide-details multiple></v-select>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="mt-3"></v-divider>

      <v-card-actions>
        <v-btn color="warning" small outlined @click="clearForm()">Clear</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submitForm(filters)">Filter</v-btn>
        <v-btn color="primary" small outlined class="ml-3" @click="closeDialog">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions,mapGetters } from "vuex";

export default {
  data () {
    return {
      menu: false,
      form: {
        productStatusSelect: [
          { text:'Cancel', value:'Cancel' },
          { text:'Live', value:'Live' },
          { text:'Warm', value:'Warm' },
          { text:'Provisioning', value:'Provisioning' },
          { text:'Provisioning Failed', value:'Provisioning Failed' },
          { text:'Provisioned', value:'Provisioned' },
          { text:'Ready', value:'Ready' },
          { text:'Upgrade', value:'Upgrade'},
          { text:'Legacy Upgrade', value:'Legacy Upgrade'},
          { text:'Verification', value:'Verification' },
          { text:'On Hold: Telecoms', value:'On Hold: Telecoms'},
          { text:'On Hold: Future Live Date', value:'On Hold: Future Live Date'},
          { text:'On Hold: Porting Issue', value:'On Hold: Porting Issue'},
          { text:'Porting', value:'Porting'},
          { text:'Order Delay', value:'Order Delay'},
          { text:'DOA', value:'DOA'},
          { text:'Fraud', value:'Fraud'},
        ],
        portKind:[
          { text:'Ipex', value:'IPEX' },
          { text:'Geographic', value:'GEOGRAPHIC' },
          { text:'Manual Geographic', value:'MANUAL_GEOGRAPHIC' },
          { text:'Non-Geographic', value:'NON_GEOGRAPHIC' },
          { text:'Reseller', value:'RESELLER' },
        ],
        status:[
          {text:'Ready to Port',value:'READY_TO_PORT'},
          {text:'Waiting for broadband',value:'WAITING_FOR_BROADBAND'},
          {text:'Porting',value:'PORTING'},
          {text:'Ported',value:'PORTED'},
          {text:'Cancelled',value:'CANCELLED'},
        ],
        automatedOrderStatus: [
          {text: 'Cancelled', value: 'CANCELLED'},
          {text: 'Committed', value: 'COMMITTED'},
          {text: 'Completed', value: 'COMPLETED'},
          {text: 'Error', value: 'ERROR'},
          {text: 'Failed', value: 'FAILED'}
        ]
      },
      filters: {page:1, paginationCount: 0, productStatus:[], portKind:[], status:["PORTING","READY_TO_PORT"], automatedOrderStatus: []}
    }
  },

  props: {
    openFilter: {
      type: Boolean,
      default: false
    },
  },

  watch: {
    openFilter(val) {
      if(val){
        let conf = this.getNumberTransfersConfigs;
        this.filters = {
          page:1, 
          paginationCount: 0, 
          productStatus:conf.productStatus, 
          portKind:conf.portKind, 
          status:conf.status,
          automatedOrderStatus: conf.automatedOrderStatus
        };
      }
    }
  },

  computed: {
    ...mapGetters("numberTransfers", [ "getNumberTransfersConfigs"]),
  },

  methods: {
    ...mapActions("numberTransfers", ["updateNumberTransfersPagination"]),

    closeDialog(){this.$emit('closeDialog');},

    clearForm() {
      this.filters.status = [];
      this.filters.portKind = [];
      this.filters.productStatus = [];
      this.filters.automatedOrderStatus = [];
    },

    submitForm(filters) {
      this.updateNumberTransfersPagination(filters);
      this.$emit('closeDialog', false);
    }
  },
}
</script>

<style>

</style>
